export const TipoEnvioAfiliacion = [
    {
        codigoProceso: 1,
        nombreProceso: "AFILIACION"
    }, {
        codigoProceso: 4,
        nombreProceso: "TRASLADO"
    }];

export const obtenerCodigoEnvio = (codigoProceso: number) => {
    return TipoEnvioAfiliacion.find(tipoEnvioAfiliacion => tipoEnvioAfiliacion.codigoProceso === codigoProceso);
};


// WEBPACK FOOTER //
// ./src/co/sura/dominio/sat/procesar_empresas/modelo/TipoEnvioAfiliacion.ts